import { ConnectorInfo } from '@blaze-shared/api-contracts-domain';
import { BaseSchema } from '@blaze-shared/schema-domain';
import { OpenDialogWorkflowNode } from '@blaze-shared/workflow-domain';

import {
  getColumnReferencesFromString,
  getNamedInputReferencesFromString,
  getParamReferencesFromString,
  getTagReferencesFromString,
} from '../../references/get-references-from-string';
import {
  WorkflowNodeColumnReference,
  WorkflowNodeNamedInputReference,
  WorkflowNodeParamReference,
  WorkflowNodeTagReference,
} from '../../references/references.models';
import { BaseWorkflowNode, WorkflowNode } from '../../registry/node.registry';

@WorkflowNode('OpenDialog')
export class OpenDialogNode extends BaseWorkflowNode<OpenDialogWorkflowNode> {
  getColumnReferences(schemas: Map<string | symbol, BaseSchema>): WorkflowNodeColumnReference[] {
    return [
      ...this.node.assignments.flatMap((assignment) => [
        ...getColumnReferencesFromString(assignment.name, schemas),
        ...getColumnReferencesFromString(assignment.value, schemas),
      ]),
    ];
  }

  getTagReferences(schemas: Map<string | symbol, BaseSchema>): WorkflowNodeTagReference[] {
    return [
      ...this.node.assignments.flatMap((assignment) => [
        ...getTagReferencesFromString(assignment.name, schemas),
        ...getTagReferencesFromString(assignment.value, schemas),
      ]),
    ];
  }

  getParamReferences(
    schemas: Map<string | symbol, BaseSchema>,
    connectors: ConnectorInfo[],
  ): WorkflowNodeParamReference[] {
    return [
      ...this.node.assignments.flatMap((assignment) => [
        ...getParamReferencesFromString(assignment.name, schemas, connectors),
        ...getParamReferencesFromString(assignment.value, schemas, connectors),
      ]),
    ];
  }

  getNamedInputReferences(
    schemas: Map<string | symbol, BaseSchema>,
  ): WorkflowNodeNamedInputReference[] {
    return [
      ...this.node.assignments.flatMap((assignment) => [
        ...getNamedInputReferencesFromString(assignment.name, schemas),
        ...getNamedInputReferencesFromString(assignment.value, schemas),
      ]),
    ];
  }
}
